import { ArrowRight } from 'lucide-react'
import { Button } from './ui/button'
import { cn } from '@/lib/utils'

interface MoreNewsButtonProps {
  onClick?: () => void
  className?: string
  disabled?: boolean
}

export function MoreNewsButton({ onClick, className, disabled = false }: MoreNewsButtonProps) {
  return (
    <Button
      variant="outline"
      size="lg"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'group w-full sm:w-auto',
        className
      )}
      aria-label="View all news articles"
    >
      <span>More News</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300 ease-in-out" aria-hidden="true" />
    </Button>
  )
}
